import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';

/* eslint-disable sonarjs/no-duplicate-string */
export const PDP_LABELS = 'ProductDetailPage.PDP_Sub';
export const headerLabels = 'global.header';
export const commonBrowseLabels = 'global.CommonBrowseLabels';
export const sortingLabels = 'global.Sorting';
//
export const lblViewThisLook = 'lbl_View_this_look';
export const lblAboutThisCollection = 'lbl_about_this_collection';
export const lblAddToBag = 'lbl_add_to_bag';
export const lblAddToBagPlpDrawerRedesign = 'lbl_add_to_bag_plp_drawer_redesign';
export const lblAvailableInOtherDepartments = 'lbl_available_in_other_departments';
export const lblBackToResults = 'lbl_back_to_results';
export const lblBagSubtotalRedesign = 'lbl_bag_subtotal_redesign';
export const lblBrierleyPromoTextGeneric = 'lbl_brierley_promo_text_generic';
export const lblBundleproductChoosecta = 'lbl_bundleproduct_choosecta';
export const lblChangeFitAndSize = 'lbl_change_fit_and_size';
export const lblChangeSize = 'lbl_change_size';
export const lblCompleteTheLook = 'lbl_complete_the_look';
export const lblFitHeadingRedesign = 'lbl_fit_heading_redesign';
export const lblFullSize = 'lbl_full_size';
export const lblGiftCard = 'lbl_gift_card';
export const lblGiftCardSelectValueRedesign = 'lbl_gift_card_select_value_redesign';
export const lblGiftCardValueRedesign = 'lbl_gift_card_value_redesign';
export const lblGiftCards = 'lbl_gift_cards';
export const lblInBag = 'lbl_in_bag';
export const lblItemsInThisLook = 'lbl_items_in_this_look';
export const lblKeyFeatures = 'lbl_key_features';
export const lblLoginModalTitle = 'lbl_login_modal_title';
export const lblLookXOfY = 'lbl_look_x_of_y';
export const lblMiniBagTitle = 'lbl_mini_bag_title';
export const lblModalHeading = 'lbl_modal_heading';
export const lblMultipackPackTitle = 'lbl_multipack_pack_title';
export const lblMultipackSingleText = 'lbl_multipack_single_text';
export const lblMyStylePlace = 'lbl_my_style_place';
export const lblOrderDetailsItemnumber = 'lbl_orderDetails_itemnumber';
export const lblOtherSizesAvailable = 'lbl_other_sizes_available';
export const lblPdpPerUnit = 'lbl_pdp_per_unit';
export const lblPdpPlaAbtest = 'lbl_pdp_pla_abtest';
export const lblPjp = 'lbl_pjp';
export const lblPlccBannerDesc = 'lbl_plcc_banner_desc';
export const lblPlccBannerDiscription = 'lbl_plcc_banner_discription';
export const lblPlccBannerDiscriptionOpen = 'lbl_plcc_banner_discription_open';
export const lblPlccBannerMy = 'lbl_plcc_banner_my';
export const lblPlccBannerPay = 'lbl_plcc_banner_pay';
export const lblPlccBannerPlace = 'lbl_plcc_banner_place';
export const lblPlccBannerRewards = 'lbl_plcc_banner_rewards';
export const lblPlccBannerSave30 = 'lbl_plcc_banner_save30';
export const lblPlccBannerTermsApply = 'lbl_plcc_banner_terms_apply';
export const lblPlccBrandImagePathPjp = 'lbl_plcc_brand_image_path_pjp';
export const lblPreferSendingViaEmail = 'lbl_prefer_sending_via_email';
export const lblProductDescriptionAllColors = 'lbl_product_description_all_colors';
export const lblProductDescriptionClaimMessage = 'lbl_product_description_claim_message';
export const lblProductDescriptionFavoriteColors = 'lbl_product_description_favorite_colors';
export const lblProductDescriptionItemPartNumber = 'lbl_product_description_item_part_number';
export const lblProductDescriptionLabel = 'lbl_product_description_label';
export const lblProductDescriptionLabelRedesign = 'lbl_product_description_label_redesign';
export const lblProductDescriptionShowLess = 'lbl_product_description_show_less';
export const lblProductDescriptionShowMore = 'lbl_product_description_show_more';
export const lblProductIncludeText = 'lbl_product_include_text';
export const lblProductSelectSize = 'lbl_product_select_size';
export const lblProductStickyButtonTitle = 'lbl_product_sticky_button_title';
export const lblPromoArea = 'lbl_promo_area';
export const lblPromoArea1 = 'lbl_promo_area_1';
export const lblPromoArea3 = 'lbl_promo_area_3';
export const lblRatingFormTitle = 'lbl_rating_form_title';
export const lblRatingReview = 'lbl_rating_review';
export const lblRatingReviewRedesign = 'lbl_rating_review_redesign';
export const lblRatingsAndReviews = 'lbl_ratings_and_reviews';
export const lblRecentlyViewed = 'lbl_recently_viewed';
export const lblReviewPastPurchases = 'lbl_review_pastPurchases';
export const lblReviewPoints = 'lbl_review_points';
export const lblReviewsRedesign = 'lbl_reviews_redesign';
export const lblRnrPlaceholder = 'lbl_rnr_placeholder';
export const lblRnrRatingSuccess = 'lbl_rnr_rating_success';
export const lblRnrReviewAnotherPurchases = 'lbl_rnr_review_another_purchases';
export const lblRnrReviewOtherPurchases = 'lbl_rnr_review_other_purchases';
export const lblRnrReviewSuccess = 'lbl_rnr_review_success';
export const lblSelectSizeErrorText = 'lbl_select_size_error_text';
export const lblSelectSizeHeader = 'lbl_select_size_header';
export const lblSelectSizeLabel = 'lbl_select_size_label';
export const lblSendAnEmailCard = 'lbl_send_an_email_card';
export const lblSimilarItems = 'lbl_similar_items';
export const lblSizeGuideRedesign = 'lbl_size_guide_redesign';
export const lblSizeHeadingRedesign = 'lbl_size_heading_redesign';
export const lblUnavailableColor = 'lbl_unavailable_color';
export const lblViewBagBtn = 'lbl_view_bag_btn';
export const lblViewLess = 'lbl_view_less';
export const lblViewMore = 'lbl_view_more';
export const lblWeFoundTheseSimilarItems = 'lbl_we_found_these_similar_items';
export const lblWriteReview = 'lbl_write_review';
export const lblYouMayAlsoLike = 'lbl_you_may_also_like';
export const lblYouRecentlyViewed = 'lbl_you_recently_viewed';
export const lblHeaderLogin = 'lbl_header_login';
export const lblCreateAnAccount = 'lbl_create_an_account';
export const lblBestSeller = 'lbl_best_seller';
export const lblTCPBazaarVoiceRating = 'lbl_TCPBazaarVoiceRating';

export const pdpLabels = {
  global: {
    header: {
      [lblHeaderLogin]: 'Login',
      [lblCreateAnAccount]: 'Create an Account',
    },
    CommonBrowseLabels: {
      [lblBestSeller]: 'TRENDING NOW',
    },
    Sorting: {
      [lblTCPBazaarVoiceRating]: 'Top Rated',
    },
  },
  ProductDetailPage: {
    PDP_Sub: {
      [lblViewThisLook]: 'View This Look',
      [lblAboutThisCollection]: 'About this collection',
      [lblAddToBag]: 'Add to Bag',
      [lblAddToBagPlpDrawerRedesign]: 'Add To Bag',
      [lblAvailableInOtherDepartments]: 'Available in other departments',
      [lblBackToResults]: 'Back To Results ',
      [lblBagSubtotalRedesign]: 'Bag Subtotal',
      [lblBrierleyPromoTextGeneric]: '2X POINTS## or ##3X POINTS',
      [lblBundleproductChoosecta]: 'Choose Items Below ',
      [lblChangeFitAndSize]: 'Change Fit & Size',
      [lblChangeSize]: 'Change Size',
      [lblCompleteTheLook]: 'Complete The Look',
      [lblFitHeadingRedesign]: 'Fit:',
      [lblFullSize]: 'Full Size',
      [lblGiftCard]: 'Gift Card ',
      [lblGiftCardSelectValueRedesign]: 'Select a Value',
      [lblGiftCardValueRedesign]: 'Value:',
      [lblGiftCards]: 'Gift Cards ',
      [lblInBag]: 'IN BAG',
      [lblItemsInThisLook]: 'Items in this look',
      [lblKeyFeatures]: 'KEY FEATURES',
      [lblLoginModalTitle]: 'Login ',
      [lblLookXOfY]: 'Look {x} of {y}',
      [lblMiniBagTitle]: 'YOUR BAG',
      [lblModalHeading]: 'Complete Your Review',
      [lblMultipackPackTitle]: 'Number of Items:',
      [lblMultipackSingleText]: 'Single',
      [lblMyStylePlace]: 'MY STYLE PLACE',
      [lblOrderDetailsItemnumber]: 'Item# ',
      [lblOtherSizesAvailable]: 'Other Sizes Available ',
      [lblPdpPerUnit]: '/ea',
      [lblPdpPlaAbtest]: 'Check out these similar styles!',
      [lblPjp]: 'PJ Place',
      [lblPlccBannerDesc]: 'for this item when you',
      [lblPlccBannerDiscription]: 'on your first purchase when you',
      [lblPlccBannerDiscriptionOpen]: 'open & use the',
      [lblPlccBannerMy]: 'MY',
      [lblPlccBannerPay]: 'Pay',
      [lblPlccBannerPlace]: 'PLACE',
      [lblPlccBannerRewards]: 'REWARDS',
      [lblPlccBannerSave30]: 'Save 30% Today',
      [lblPlccBannerTermsApply]: '. Terms Apply',
      [lblPlccBrandImagePathPjp]: '/ecom/assets/static/icon/pjp-cc.png',
      [lblPreferSendingViaEmail]: 'Prefer sending via email? ',
      [lblProductDescriptionAllColors]: 'All Colors',
      [lblProductDescriptionClaimMessage]: 'Big Fashion, Little Prices ',
      [lblProductDescriptionFavoriteColors]: 'Favorite Colors',
      [lblProductDescriptionItemPartNumber]: 'Item #: ',
      [lblProductDescriptionLabel]: 'PRODUCT DESCRIPTION',
      [lblProductDescriptionLabelRedesign]: 'Product Details',
      [lblProductDescriptionShowLess]: 'Show Less',
      [lblProductDescriptionShowMore]: 'Show More',
      [lblProductIncludeText]: 'Pack Includes',
      [lblProductSelectSize]: 'Select a Size ',
      [lblProductStickyButtonTitle]: 'Select Size',
      [lblPromoArea]: 'PROMO AREA',
      [lblPromoArea1]: 'PROMO AREA 1 ',
      [lblPromoArea3]: 'PROMO AREA 3',
      [lblRatingFormTitle]: 'Write A Review ',
      [lblRatingReview]: 'RATINGS AND REVIEWS',
      [lblRatingReviewRedesign]: 'Ratings & Reviews',
      [lblRatingsAndReviews]: 'RATINGS & REVIEWS ',
      [lblRecentlyViewed]: 'People Also Viewed',
      [lblReviewPastPurchases]: 'Review Your Purchases',
      [lblReviewPoints]: 'Every 5 products reviewed earn 100 points towards your next purchase!',
      [lblReviewsRedesign]: 'Reviews',
      [lblRnrPlaceholder]: 'Tell us how you feel about this purchase',
      [lblRnrRatingSuccess]: 'Rating submitted!',
      [lblRnrReviewAnotherPurchases]: 'RATE & REVIEW ANOTHER PURCHASE',
      [lblRnrReviewOtherPurchases]: 'Review your other purchases',
      [lblRnrReviewSuccess]: 'We have received your review for',
      [lblSelectSizeErrorText]: 'Please select a size',
      [lblSelectSizeHeader]: 'Select a Size',
      [lblSelectSizeLabel]: 'Select a Size',
      [lblSendAnEmailCard]: 'Send an E-Gift Card ',
      [lblSimilarItems]: 'Similar item to consider',
      [lblSizeGuideRedesign]: 'Size Guide',
      [lblSizeHeadingRedesign]: 'Size:',
      [lblUnavailableColor]: 'Not available in selected color',
      [lblViewBagBtn]: 'VIEW BAG',
      [lblViewLess]: 'View less',
      [lblViewMore]: 'View more',
      [lblWeFoundTheseSimilarItems]: 'We Found These Similar Items',
      [lblWriteReview]: 'Write A Review ',
      [lblYouMayAlsoLike]: 'You May Also Like',
      [lblYouRecentlyViewed]: 'RECENTLY VIEWED',
      lbl_show_in_stock_stores: 'SHOW-IN STOCK STORES',
      lbl_multipack_pack_text: '-Pack',
    },
  },
};

export function getPdpLabels() {
  return getLabelFromCopyOrFromTranslation(PDP_LABELS, pdpLabels);
}

export function getSortingLabels() {
  return getLabelFromCopyOrFromTranslation(sortingLabels, pdpLabels);
}

export function getCommonBrowseLabels() {
  return getLabelFromCopyOrFromTranslation(commonBrowseLabels, pdpLabels);
}

export function getHeaderLabels() {
  return getLabelFromCopyOrFromTranslation(headerLabels, pdpLabels);
}

export function getPickupStoreModalLabels() {
  return {
    ...getPdpLabels(),
    ...getSortingLabels(),
    ...getCommonBrowseLabels(),
    ...getHeaderLabels(),
  };
}
